
export default {
  name: 'AddressBookSearchPanel',

  props: {
    projectUuid: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      isSubmitForm: false,
      searchParams: {
        description: '',
        num_a: '',
        isVip: '',
      },
    };
  },

  watch: {
    searchParams: {
      handler(newVal) {
        this.$emit('changeFilterBy', newVal);
      },
      deep: true,
    },
  },

  methods: {
    async clearSearchParams() {
      this.searchParams.description = '';
      this.searchParams.num_a = '';
      this.searchParams.isVip = '';
    },
  },
};
